import styled from "styled-components";

import { COLORS, FONT_SIZE, FONTS } from "../../../constants/Styles";

export const Container = styled.div<{
  lessPadding?: boolean;
  fullScreen?: boolean;
}>`
  ${({ fullScreen }) =>
    fullScreen
      ? `
      width: 100%;
      height: 100%;
      `
      : `
      
      max-width: 100vw;
      max-height: 100vh;
      `}
  background-color: ${COLORS.background};
  opacity: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: ${({ lessPadding }) => (lessPadding ? "1rem" : "2rem")};
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  flex: 1;
`;

export const CloseHint = styled.div`
  color: ${COLORS.secondaryLight};
  text-align: center;
  flex: 1;
`;

export const Content = styled.div`
  opacity: 1;
  flex: 1;
`;

export const CloseBadge = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
